var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-point-create-edit p1"},[_c('app-custom-table',{ref:"table",attrs:{"tableData":_vm.itemList,"tableColumns":_vm.tableColumns,"noPagination":"","selectionMode":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }